import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // Добавляем HelmetProvider
import PageMaine from "./components/PageMain";
import Contacts from "./components/contacts/Contacts";
import MainPageM from "./components/mobile/MainPageM";
import NavBar from "./components/navbar/NavBar";
import NavBarM from "./components/mobile/navbarM/NavBarM";
import MenuBurger from "./components/mobile/menuBurger/MenuBurger";
import { useSelector } from "react-redux";
import { selStatus, selectMenu, selectBasShow } from "./redux/selectors";
import Basket from "./components/basket/Basket";
import Order from "./components/order/Order";
import Preloder from "./components/Preloder";
import Documents from "./components/documents/Documents";
import GeneralCatalog from "./components/pages/catalog/GeneralCatalog";
import Technologes from "./components/technology/Technology";
import DocumentsM from "./components/documents/DocumentsM";
import TechnologyCardLora from "./components/technology/TechnologyCardLora";
import TechnologyCardIot from "./components/technology/TechnologyCardIot";
import TechnologyCardNBIot from "./components/technology/TechnologyCardNBIot";
import TechnologyCardMbus from "./components/technology/TechnologyCardMbus";
import TechnologyCardRS from "./components/technology/TechnologyCardRS";
import Company from "./components/company/Company";
import ProductContainer from "./components/pages/catalog/ProductContainer";
import Sitemap from "./components/Sitemap";
import Services from "./components/services/Services";
import MeterVerif from "./components/services/MeterVerif";
import RemoteData from "./components/services/RemoteData";

function App() {
  const status = useSelector(selStatus);
  const menu = useSelector(selectMenu);
  const showBasket = useSelector(selectBasShow);
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const resize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <HelmetProvider>
      <div className="font-dancing-script">
        {Number(size.width) > 1025 ? (
          <>
            {status === "loading" && <Preloder />}
            <NavBar />
            <Basket />
            <Order />
            <div style={showBasket ? { opacity: 0.2 } : undefined}>
              <Routes>
                <Route path="/*" element={<PageMaine />} />
                <Route path="/contact" element={<Contacts />} />
                {/*<Route path="/about" element={<Company />} />*/}
                <Route path="/product/:productId" element={<ProductContainer />} />
                <Route path="/technology/lora" element={<TechnologyCardLora />} />
                <Route path="/technology/nb-iot" element={<TechnologyCardNBIot />} />
                <Route path="/technology/iot" element={<TechnologyCardIot />} />
                <Route path="/technology/m-bus" element={<TechnologyCardMbus />} />
                <Route path="/technology/rs-485" element={<TechnologyCardRS />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/meter-verif" element={<MeterVerif />} />
                <Route path="/services/remote-data" element={<RemoteData />} />
                <Route path="/sitemap" element={<Sitemap />} />
              </Routes>
            </div>
          </>
        ) : (
          <>
            {status === "loading" && <Preloder />}
            <NavBarM />
            <Basket />
            <Order />
            <div className="mobile" style={{ width: "100%", overflow: "hidden" }}>
              {menu && <MenuBurger />}
              <Routes>
                <Route path="/*" element={<MainPageM />} />
                <Route path="/contact" element={<Contacts />} />
               <Route path="/about" element={<Company />} />
                <Route path="/catalog" element={<GeneralCatalog size={Number(size.width)} />} />
                <Route path="/product/:productId" element={<ProductContainer mobile="mobile" />} />
                <Route path="/technologes" element={<Technologes />} />
                <Route path="/technology/loraa" element={<TechnologyCardLora />} />
                <Route path="/documents" element={<DocumentsM />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/meter-verif" element={<MeterVerif />} />
                <Route path="/services/remote-data" element={<RemoteData />} />
                <Route path="/sitemap" element={<Sitemap />} />
              </Routes>
            </div>
          </>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
